import React from "react";
import { useState, useEffect } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import { useNavigate } from "react-router-dom";
import ViewData from "../../components/grids/ViewDatagrid";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";

import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import CircularProgress from "@mui/material/CircularProgress";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Toolbar,
  IconButton,
  Autocomplete,
  Divider,
  ListItemButton,
  Tooltip,
} from "@mui/material";
import { List, ListItem, ListItemText } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { sessiondata } from "../../assets/Griddata"; // Import dataset
import { LICENSE_API_04 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import currencyFormat from "../../utils/common/CurrencyFormat";
function LicenseAddOns() {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]); // To track selected rows
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [subscriptionType, setSubscriptionType] = useState("Annual");
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERREFCODE, EXPDATE } = SYS_USER.USER_PARAM || {};
  const MODULECODE = 5;

  //   const gotToPage = () => {
  //     navigate("/ViewUsers");
  //   };

  const handleNextPage = () => {
    navigate("/AddLicenseAddOns", { state: { selectedRows } }); // Pass selectedRows to the next page
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch data from the API
        const result = await externalgetApi(LICENSE_API_04, "get", {
          COMPCODE: COMPCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        // Extract MODULECODE from SYS_USER.USER_PARAM

        console.log("Filtered data:", MODULECODE);
        // Filter the result based on the MODULECODE
        const filtered = result.filter(
          (item) => item.MODULECODE === MODULECODE
        );
        setFilteredData(filtered);
        // Set the filtered data to state
        console.log("Filtered data:", filteredData); // Log the filtered data
      } catch (err) {
        setError(err); // Handle errors
      } finally {
        setIsLoading(false); // Stop loading
      }
    };

    fetchData(); // Call the fetchData function
  }, [COMPCODE]); // Re-run the effect when COMPCODE changes

  const groupedData = (data || []).reduce((acc, item) => {
    const { MODULENAME, ADDONCODE, ADDONNAME, ARATE, MRATE, RATE, MODULECODE } =
      item;

    // Initialize MODULENAME group if not present
    if (!acc[MODULENAME]) {
      acc[MODULENAME] = {};
    }

    // Initialize ADDONCODE group within MODULENAME if not present
    if (!acc[MODULENAME][ADDONCODE]) {
      acc[MODULENAME][ADDONCODE] = {
        ADDONNAME,
        MODULECODE,
        ARATE,
        MRATE,
        RATE,
      };
    }

    return acc;
  }, {});

  console.log("Grouped Data:", groupedData);

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      //   onClick: (GROUPCODE) => handleItemClick(GROUPCODE, "Edit"),
    },
  ];
  // Track selected checkboxes

  const handleCheckboxChange = (event, addonDetails) => {
    const { moduleName, addonName, displayRate, addonCode, moduleCode } =
      addonDetails;
    const newSelectedRows = [...selectedRows];

    if (event.target.checked) {
      // Add the selected details to the state, including subscriptionType
      newSelectedRows.push({
        moduleName,
        addonName,
        displayRate,
        addonCode,
        subscriptionType, // Include subscription type (annual or monthly)
        moduleCode: moduleCode || MODULECODE,
      });
    } else {
      // Remove the selected details from the state based on addonCode
      const indexToRemove = newSelectedRows.findIndex(
        (row) => row.addonCode === addonCode
      );
      if (indexToRemove > -1) {
        newSelectedRows.splice(indexToRemove, 1);
      }
    }

    setSelectedRows(newSelectedRows);
  };

  const subscriptionOptions = [
    { label: "Monthly", value: "Monthly" },
    { label: "Annual", value: "Annual" },
  ];

  const [selectedOption, setSelectedOption] = useState(subscriptionOptions[1]); // Default to "Annual"
  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        GROUPCODE: item.GROUPCODE,
        GROUPNAME: item.GROUPNAME,
      }))
    : [];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Account</Link>
                <Link underline="none">License Addon</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              {/* <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  size="medium"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack> */}
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box>
        <Box
          ml={15}
          mt={16}
          p={3}
          mr={3}
          sx={{
            maxHeight: "75vh",
            overflowY: "auto",
            border: "1px solid #ddd", // Box border
            boxShadow: 1, // Optional shadow for styling
          }}
        >
          <Box
            sx={{
              padding: "16px",

              ml: 55,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {/* Typography for Subscription Title */}
            <Typography variant="h5" gutterBottom>
              Subscription
            </Typography>

            {/* Autocomplete for selecting subscription type */}
            <Autocomplete
              options={subscriptionOptions}
              value={subscriptionOptions.find(
                (option) => option.value === subscriptionType
              )} // Match the current state with the option
              onChange={(event, newValue) =>
                setSubscriptionType(newValue?.value || "")
              } // Update state when selection changes
              getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subscription Type"
                  variant="outlined"
                  size="small"
                />
              )}
              sx={{
                width: 200,
                ml: 3,
              }}
              ListboxProps={{
                style: {
                  maxHeight: 150,
                  backgroundColor: theme.palette.background.paper,
                },
              }}
              noOptionsText={
                <div
                  style={{
                    backgroundColor: theme.palette.background.paper,
                    padding: "8px",
                  }}
                >
                  No options
                </div>
              }
            />
          </Box>

          <Grid container spacing={3}>
            {groupedData && Object.keys(groupedData).length > 0 ? ( // Ensure groupedData is not null/undefined and has keys
              Object.keys(groupedData).map((moduleName) => (
                <Grid item xs={12} sm={4} key={moduleName}>
                  <Box
                    sx={{
                      padding: 2,
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      marginBottom: 2,
                    }}
                  >
                    <Typography variant="h6" gutterBottom>
                      {moduleName} {/* Display the module name */}
                    </Typography>
                    <Box
                      sx={{
                        border: "1px solid #ddd", // Add border around each box
                        padding: "16px",
                        minHeight: "50vh",
                        maxHeight: "50vh",
                        overflowY: "auto",
                        borderRadius: "8px",
                        boxShadow: 1, // Optional: add shadow for a 3D effect
                      }}
                    >
                      <List>
                        {Object.keys(groupedData[moduleName]).map(
                          (addonCode) => {
                            const addon = groupedData[moduleName][addonCode];
                            // Determine the rate to display based on subscription type
                            const displayRate =
                              subscriptionType === "monthly"
                                ? currencyFormat(addon.MRATE)
                                : subscriptionType === "annual"
                                ? currencyFormat(addon.ARATE)
                                : currencyFormat(addon.RATE);

                            return (
                              <ListItem key={addonCode} disablePadding>
                                <ListItemButton>
                                  <Checkbox
                                    edge="start"
                                    checked={
                                      // Check if the addonCode is selected or if the MODULECODE matches the SYS_USER's MODULECODE
                                      selectedRows.some(
                                        (row) => row.addonCode === addonCode
                                      )
                                      // || (MODULECODE === addon.MODULECODE)
                                    }
                                    onChange={(e) =>
                                      handleCheckboxChange(e, {
                                        moduleName, // Pass module name
                                        addonName: addon.ADDONNAME, // Pass addon name
                                        displayRate, // Pass display rate
                                        addonCode, // Pass addon code
                                        moduleCode: addon.MODULECODE, // Pass module code
                                        isModuleCodeMatch:
                                          MODULECODE === addon.MODULECODE, // Pass whether the MODULECODE matches
                                      })
                                    }
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                      "aria-labelledby": `checkbox-list-label-${addonCode}`,
                                    }}
                                  />

                                  <ListItemText
                                    id={`checkbox-list-label-${addonCode}`}
                                    primary={addon.ADDONNAME}
                                    secondary={`Rate: ${displayRate}`} // Display the correct rate
                                  />
                                </ListItemButton>
                              </ListItem>
                            );
                          }
                        )}
                      </List>
                    </Box>
                  </Box>
                </Grid>
              ))
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "60vh",
                }}
              >
                <CircularProgress color="primary" />
              </Box>
            )}
          </Grid>
        </Box>
        <Box
          sx={{
            position: "fixed", // Fix position to stay at the bottom-right
            bottom: 5, // Adjust distance from the bottom
            right: 25, // Adjust distance from the right
            zIndex: 10, // Ensure it's above other elements
          }}
        >
          <Button
            onClick={handleNextPage}
            variant="contained"
            endIcon={<DoubleArrowIcon />}
            sx={{
              background: theme.palette.primary.main,
              color: theme.palette.text.buttontxt,
              textTransform: "capitalize",
              letterSpacing: "1px",
              width: "80px",
            }}
            id="btnback"
          >
            Next
          </Button>
        </Box>
      </Box>
    </div>
  );
}

export default LicenseAddOns;
